import React from "react";
import { useNavigate } from "react-router-dom";
import { ShieldAlert, ArrowLeft } from "lucide-react";
import "./AccessBlocked.css";

export default function AccessBlocked({
  title,
  description,
  primaryActionLabel = "Go to dashboard",
  primaryActionPath = "/",
  secondaryActionLabel = "Go back",
  icon: Icon = ShieldAlert,
  onPrimaryAction,
  onSecondaryAction,
}) {
  const navigate = useNavigate();

  function handlePrimary() {
    if (onPrimaryAction) {
      onPrimaryAction();
      return;
    }

    navigate(primaryActionPath);
  }

  function handleSecondary() {
    if (onSecondaryAction) {
      onSecondaryAction();
      return;
    }

    navigate(-1);
  }

  return (
    <div className="access-blocked">
      <div className="access-blocked__card">
        <div className="access-blocked__icon">
          <Icon size={28} />
        </div>

        <h2>{title}</h2>
        <p>{description}</p>

        <div className="access-blocked__actions">
          <button
            type="button"
            className="access-blocked__primary"
            onClick={handlePrimary}
          >
            {primaryActionLabel}
          </button>

          <button
            type="button"
            className="access-blocked__secondary"
            onClick={handleSecondary}
          >
            <ArrowLeft size={14} />
            {secondaryActionLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
